import { render, staticRenderFns } from "./chatItem.vue?vue&type=template&id=6462d23e&scoped=true"
import script from "./chatItem.vue?vue&type=script&lang=js"
export * from "./chatItem.vue?vue&type=script&lang=js"
import style0 from "./chatItem.vue?vue&type=style&index=0&id=6462d23e&prod&lang=scss"
import style1 from "./chatItem.vue?vue&type=style&index=1&id=6462d23e&prod&lang=scss&scoped=true"
import style2 from "./chatItem.vue?vue&type=style&index=2&id=6462d23e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6462d23e",
  null
  
)

export default component.exports